import { render, staticRenderFns } from "./NwForm.vue?vue&type=template&id=4811ff20&scoped=true&"
import script from "./NwForm.vue?vue&type=script&lang=js&"
export * from "./NwForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4811ff20",
  null
  
)

export default component.exports